import classNames from 'classnames'

import { EMPTY_STRING } from '../../../constants/common'
import { NUMBER_SIZE } from '../../../constants/size'
import DefaultText from '../../Text'

import * as styles from './Day.module.css'

/**
 * @typedef {ReactTagProps<TTag>} DayProps
 * @template {ReactTag} TTag
 *
 * @property {string} [Element]
 * @property {React.ComponentType} [Text]
 * @property {React.ReactNode} [children]
 * @property {string} [className]
 * @property {Object} [textProps]
 * @property {NumberSize} [size]
 * @property {Object} [sizeClassNames]
 */

/**
 * @param {DayProps} props
 */
function Day({
  Element = 'div',
  Text = DefaultText,
  children,
  className = styles.Day,
  size = NUMBER_SIZE.size40,
  sizeClassNames = styles,
  textProps: {
    className: textClassName = styles.text,
    ...textProps
  } = EMPTY_STRING,
  ...elementProps
}) {
  const elementClassName = classNames(className, {
    [sizeClassNames[`size${size}`]]: true,
  })

  return (
    <Element {...elementProps} className={elementClassName}>
      <Text {...textProps} className={textClassName}>
        {children}
      </Text>
    </Element>
  )
}

export default Day
